module.exports = __webpack_public_path__ + "img/product1.92f5b606.png";